import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import SupportPage from "./pages/SupportPage.js";

export const soporteRoutes = (
  <Route element={<RequireModuleAccess module="soporte" />}>
    <Route path="/soporte" element={<SupportPage />} />
  </Route>
);
